import { render } from "./moreSaled.vue?vue&type=template&id=6d97c370&scoped=true"
import script from "./moreSaled.vue?vue&type=script&lang=js"
export * from "./moreSaled.vue?vue&type=script&lang=js"

import "./moreSaled.vue?vue&type=style&index=0&id=6d97c370&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d97c370"]])

export default __exports__